import { Divider, LabeledCheckbox, Typography } from '@fox/atoms';
import { Padded } from '@fox/layout';
import { Card } from '@mui/material';
import React from 'react';
import { useFinancialContext } from '../../../financial-config-context';
import { OptionsInput, PlanOption, SwiftFoxPlansResult } from '../contracts';
import { formatCurrency } from '../shared';

export function OptionSelector({
	title,
	options,
	selectedPlan,
	selectedFeeId,
	selectedOptions,
	toggleOption
}: {
	title: string;
	options: Array<PlanOption>;
	selectedPlan: SwiftFoxPlansResult;
	selectedFeeId: string;
	selectedOptions: Array<OptionsInput>;
	toggleOption: (id: string, limit: number) => void;
}) {
	const { currencies } = useFinancialContext();
	const feeInterval = selectedPlan?.fees.find(a => a.id === selectedFeeId);
	const currency = feeInterval?.currency ?? currencies.default;
	const usableOptions = options?.filter(a => {
		return a.interval === null || (a.interval === feeInterval?.interval && (a.units ?? 1) === (feeInterval.units ?? 1));
	});

	if (!usableOptions.length) return null;

	return (
		<>
			<Typography variant="subtitle2">{title}</Typography>
			<Card variant="outlined">
				{usableOptions?.map((d, idx) => {
					const selected = selectedOptions.find(o => o.id === d?.id);
					return (
						<React.Fragment key={d?.id ?? idx}>
							{idx !== 0 && <Divider />}
							<Padded>
								<LabeledCheckbox
									label={`${d?.name} (${formatCurrency(d.amount, currency)})`}
									checked={Boolean(selected)}
									onChange={() => {
										toggleOption(d.id, d.defaultLimit);
									}}
								/>
							</Padded>
						</React.Fragment>
					);
				})}
			</Card>
		</>
	);
}
